import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';

import * as actions from '../../../store/actions';

const Composer = props => {
  const [text, setText] = React.useState('');

  const handleTextChange = event => {
    if (event.target.value === '\n') {
      setText('');
    } else {
      setText(event.target.value);
    }
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (text.length > 0) {
        props.dispatch(actions.properties.createPropertyEvent({
          eventId: uuidv4(),
          icon: 'APP',
          text,
          senderName: props.appUserDisplayName,
          senderId: props.appUserId,
          propertyId: props.propertyId,
          serviceProviderId: props.serviceProviderId,
          instanceId: props.instanceId,
          createdAt: new Date().valueOf()
        }));
      }
      setText('');
    }
  };

  const classes = useStyles();

  return (
    <TextField
      className={classes.input}
      placeholder={`Message ${props.propertyDisplayName}`}
      multiline
      variant='outlined'
      value={text}
      onChange={handleTextChange}
      onKeyDown={handleKeyDown}
    />
  );
};

const useStyles = makeStyles(theme => ({
  input: {
    marginBottom: 8,
    marginLeft: 8,
    marginRight: 8,
    marginTop: 8
  }
}));

const mapStateToProps = (state, ownProps) => {
  const appUserId = state.auth.user.username;
  const property = state.properties.byId[ownProps.propertyId];
  const user = state.users.byId[appUserId];
  return {
    appUserId: state.auth.user.username,
    appUserDisplayName: user !== undefined ? user.displayName : null,
    serviceProviderId: state.auth.user.attributes['custom:service_provider_id'],
    propertyDisplayName: property !== undefined ? property.displayName : null
  };
};

export default connect(mapStateToProps)(Composer);